import { Button } from "../ui/button";
import { Workstream } from "./Plan"
import { useContext } from 'react'
import { PlanBuilderContext } from './Plan'
import { Layers } from "lucide-react";
import FrmWorkstream from './frmWorkstream'; // Adjust the import path as necessary
import DeleteButton from "../ui/delete-button";
import { CloseIcon } from "../ui/Icons/TooltipIcon";

interface WorkstreamBuilderProps {
    workstream: Workstream
    }

const WorkstreamBuilder = ({workstream} : WorkstreamBuilderProps) => {
    const props = useContext(PlanBuilderContext);

  return (
    <div className="flex flex-col border-2 border-gray-500 rounded-md ml-2 min-w-[450px] h-min">
      <div className="flex flex-row justify-between items-center px-2 bg-planbuilder-workstream-header text-planbuilder-workstream-header-foreground">
          <div>
          {workstream.name}
          </div>
          <div className='flex flex-row my-auto'>
            <DeleteButton
              action={() => props.deleteWorkstream(workstream.id)}
              title={"Delete Workstream?"}
              message={"Are you sure you want to delete " + workstream.name + "?"}
              tooltip={"Delete " + workstream.name}
            />
            <div className='my-auto' onClick={() => props.setShowEditForm(false)} ><CloseIcon className="text-white rounded-md cursor-pointer hover:bg-red-500" /></div>
          </div>
      </div>
      <div className="flex flex-row justify-between p-4">
        <div className="flex flex-col w-full"><FrmWorkstream workstream={workstream} /></div>
        <div className="flex flex-col justify-end"><Button className="ml-2" onClick={props.addWorkPackage}><Layers />Add Work Package</Button></div>
      </div>
    </div>
  )
}

export default WorkstreamBuilder